import { z } from 'zod'

/** 日期 Schema */
export const monthValueSchema = z.union([
  z.string().regex(/^$/),
  z.string().regex(/^\d{4}\/(0[1-9]|1[0-2])$/)
])
/** 日期 */
export type MonthValue = z.infer<typeof monthValueSchema>
